import Rest from '@services/Rest';
import getStandardInstance from '@utils/getStandardInstance';

const standard = getStandardInstance();

/**
 * @typedef {WithdrawalsAnalysisService}
 */
export default class WithdrawalsAnalysisService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/withdrawals-analysis'

  blob(record) {
    standard.defaults.responseType = 'blob';
    return this.post('/export', record);
  }

  checkStatus(data) {
    standard.defaults.responseType = 'json';
    return this.post('/check-status', data);
  }

  getGroupItems(queryString) {
    standard.defaults.responseType = 'json'
    return this.get(`/group?${queryString}`);
  }

  search(params) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`?${queryString}`);
  }

  groups(queryString) {
    standard.defaults.responseType = 'json'
    return this.get(`/groups?${queryString}`);
  }

  getGroupWithdrawals(queryString) {
    standard.defaults.responseType = 'json'
    return this.get(`/groups/items?${queryString}`);
  }

  getGroupPaginated(payload) {
    standard.defaults.responseType = 'json'
    return this.post('/groups/items/paginated', payload);
  }

  getStatuses() {
    standard.defaults.responseType = 'json';
    return this.get('/statuses');
  }

  getSalesWithFilters(withdrawalId, params) {
    const queryString = new URLSearchParams(params).toString();
    return this.get(`/withdrawals/${withdrawalId}/sales?${queryString}`);
  }

}
